import { ApplicationState } from '..';

export const isPathwayProvider = (state: ApplicationState) => state.config.pathwayIds?.length > 0;

export const hasPathways = (state: ApplicationState) => state.config.relatedPathways?.length > 0;

export const getStages = (state: ApplicationState) => {
  return state.config.stages;
};

export const getTags = (state: ApplicationState) => {
  return state.config.tags;
};

export const getOfferOrIntakeMode = (state: ApplicationState) => {
  return state.config.multiOfferStudentFlow ? 'Offer' : 'Intake';
};

export const getPartnerServiceProviders = (state: ApplicationState) => {
  return state.config.partners;
};
export const getIsConfigLoaded = (state: ApplicationState) => state.config.isLoaded;

export const getFeatureFlags = (state: ApplicationState) => state.config.featureFlags;
